var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-129 -759.001)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(-5945.001 6447)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M6092.458-5666H6076a2,2,0,0,1-2-2v-18a2,2,0,0,1,2-2h18a2,2,0,0,1,2,2v12.959l-7.042,7.04h3.5Zm3.541-1.927h0v-3.734l0,3.66C6096-5667.975,6096-5667.95,6096-5667.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M 6088.12890625 -5667.9990234375 L 6094.00048828125 -5673.869140625 L 6094.00048828125 -5685.99755859375 C 6094 -5685.99853515625 6093.99951171875 -5685.9990234375 6093.99951171875 -5685.9990234375 L 6076.00146484375 -5685.9990234375 C 6076.0009765625 -5685.99853515625 6076.0009765625 -5685.99853515625 6076.00048828125 -5685.998046875 L 6075.99951171875 -5668.001953125 C 6076 -5668.0009765625 6076.0009765625 -5668 6076.001953125 -5667.9990234375 L 6088.12890625 -5667.9990234375 M 6092.45849609375 -5665.9990234375 L 6076 -5665.9990234375 C 6074.8974609375 -5665.9990234375 6074.00048828125 -5666.896484375 6074.00048828125 -5668 L 6074.00048828125 -5685.99951171875 C 6074.00048828125 -5687.10205078125 6074.8974609375 -5687.9990234375 6076 -5687.9990234375 L 6093.99951171875 -5687.9990234375 C 6095.10302734375 -5687.9990234375 6096.00048828125 -5687.10205078125 6096.00048828125 -5685.99951171875 L 6096.00048828125 -5673.04052734375 L 6088.95849609375 -5666.00048828125 L 6092.45849609375 -5666.0009765625 L 6092.45849609375 -5665.9990234375 Z M 6095.9990234375 -5667.92578125 L 6095.9970703125 -5667.92578125 L 6095.99853515625 -5671.66015625 L 6096.00048828125 -5668 C 6096.00048828125 -5667.97509765625 6096 -5667.9501953125 6095.9990234375 -5667.92578125 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6074-5681v-5a2,2,0,0,1,2-2h5a1.994,1.994,0,0,1,1.414.586l-7.828,7.829A1.993,1.993,0,0,1,6074-5681Z",
    transform: "translate(-5932 6460)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.19800672.svg";
export { ForwardRef as ReactComponent };